import React, { useState } from 'react';
import { LOCALE_RU } from '../constant';
import ItemNameContent from './ItemNameContent';
import LocaleAffixedField from './LocaleAffixedField';

export type ItemNameService = {
    getLocalization: (
        localeCode: string,
        itemCode: unknown,
        capitalize?: boolean,
        i18n?: unknown,
    ) => string;
    getPlaceholder: () => string;
};

export type ItemNameSaveService = {
    updateItemLocalization: (locale: string, value: string) => void;
};

type ItemNameProps = {
    itemCode: unknown;
    itemService: ItemNameService;
    itemSaveService: ItemNameSaveService;
};

const ItemName = ({ itemCode, itemSaveService, itemService }: ItemNameProps) => {
    const [currentLocaleValue, setCurrentLocaleValue] = useState(LOCALE_RU);

    return (
        <LocaleAffixedField
            locale={currentLocaleValue}
            onLocaleChange={setCurrentLocaleValue}
        >
            <ItemNameContent
                itemCode={itemCode}
                localeCode={currentLocaleValue}
                itemSaveService={itemSaveService}
                itemService={itemService}
            />
        </LocaleAffixedField>
    );
};

export default ItemName;
